import React, { useState, useEffect } from "react";
import { useSubheader } from "@metronic/layout";
import { Alert, Accordion } from "react-bootstrap";
import { HospitalData } from "@components/panels/hospital-data/hospital-data";
import { MedicalFees } from "@components/panels/medical-fee/medical-fees";
import { InssuredData } from "@components/panels/insured-data/inssured-data";
import { FamilyData } from "@components/panels/family-data/family-data";
import Documentation from "@components/panels/documentation/documentation";
import { MedicDataTreating } from "@components/panels/medic-treating-data/medic-data-treating";
import { Binnacle } from "@components/panels/binnacle/binnacle";
import { InsuranceData } from "@components/panels/insurance-data/insurance-data";
import { Opinion } from "@components/panels/dictum/dictum";
import { getBySlug } from "@services/hospitalization";
import AuthLetters from "@components/panels/auth-letter/auth-letters";
import CaseHeader from "@components/panels/case-header/case-header";
import BlockCaseContext from "@contexts/block-case-context";
import { SufferingData } from "@components/panels/suffering-data/suffering-data";

const GeneralConsultDetails = (props) => {
  const subheader = useSubheader();

  const { slug } = props.match.params;

  const params = new URLSearchParams(props.location.search);
  const isInsuranceMode = params.get("modo") === "aseguradora";

  const [caseRecord, setCaseRecord] = useState({});
  const [totalLetters, setTotalLetters] = useState(0.0);
  const [shouldBlockCase, setShouldBlockCase] = useState(true);

  useEffect(() => {
    subheader.setTitle("Consulta General");

    getBySlug(slug).then((response) => {
      setCaseRecord(response.data);
    });
  }, [slug]);

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Consulta General
      </Alert>

      <CaseHeader caseRecord={caseRecord} requiresTabulationSlot={<></>} />

      <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
        <Accordion className="mt-5">
          <HospitalData
            icon="fa-search"
            eventKey="0"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <InssuredData
            icon="fa-search"
            eventKey="2"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <FamilyData
            icon="fa-search"
            eventKey="3"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <MedicDataTreating
            icon="fa-search"
            eventKey="4"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <InsuranceData
            icon="fa-search"
            eventKey="6"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <Opinion
            icon="fa-search"
            eventKey="7"
            data={caseRecord}
            disabledAll={true}
            totalLetters={totalLetters}
            bindSubmitForm={() => {}}
          />
          {isInsuranceMode && <SufferingData
            icon="fa-pencil-alt"
            eventKey="1"
            data={caseRecord}
            hideForm={true}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />}
          <MedicalFees
            icon="fa-search"
            eventKey="10"
            data={caseRecord}
            hideBtnInsurance={false}
            hideFormCreate={true}
            disabledAll={true}
            showForm={false}
            {...props}
          />
          <AuthLetters
            icon="fa-search"
            showForm={false}
            hideDeleteOption={true}
            eventKey="8"
            data={caseRecord}
            disabledAll={false}
            setTotalLetters={setTotalLetters}
            {...props}
          />
          <Documentation
            icon="fa-search"
            eventKey="9"
            data={caseRecord}
            disabledAll={true}
            {...props}
          />
        </Accordion>
        <Accordion defaultActiveKey="10" className="mt-5">
          <Binnacle
            icon="fa-search"
            eventKey="10"
            hideButton={true}
            data={caseRecord}
            disabledAll={true}
            eventStage="Consulta General"
            comment="SE ACTUALIZA TIPO DE TRAMITE"
            {...props}
          />
        </Accordion>
      </BlockCaseContext.Provider>
    </>
  );
};

export default GeneralConsultDetails;

